import { Form, InputNumber } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { PartialSKU, StepActionTypeEnum } from 'domains/skuDomain';
import { useTranslation } from 'react-i18next';
import { useMount } from 'ahooks';
import { useAppDispatch } from 'app/hooks';

type Props = {
  sku: PartialSKU;
};

export const Step3Quantities = ({ sku }: Props) => {
  const [form] = useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
  };

  useMount(() => {
    const quantityValue = {
      defaultQty: sku.defaultQty,
      orientation: sku.orientation,
    };

    form.setFieldsValue(quantityValue);

    dispatch.sku.registerStepAction({
      [StepActionTypeEnum.STEP1_QUANTITIES]: submit,
    });
  });

  const submit = async () => {
    if (sku.readonly) {
      return true;
    }
    try {
      const formValue = await form.validateFields();
      return dispatch.sku.updateQuantities({ ...sku, ...formValue });
    } catch {
      // do nothing when form invalid
      return false;
    }
  };

  return (
    <>
      <div className="single-sku-config-wizard-step-title">
        {t('platform.sku.wizard.whatDefault')}{' '}
        <span className="brand-green">
          {' '}
          {t('platform.sku.wizard.qtyOrientation')}
        </span>
      </div>
      <div className="single-sku-config-wizard-step-content">
        <Form
          layout={'horizontal'}
          form={form}
          {...formItemLayout}
          autoComplete="off"
        >
          <Form.Item
            label={t('platform.sku.wizard.quantity.form.label.defaultQuantity')}
            name="defaultQty"
            rules={[{ required: true }, { type: 'number', min: 1, max: 9999 }]}
          >
            <InputNumber disabled={sku.readonly} />
          </Form.Item>
        </Form>
      </div>
    </>
  );
};
